import { Identifier } from "../../core";
export class CrossSellingItemTypeId extends Identifier {
    constructor(id) {
        super("CrossSellingItemTypeId", id);
    }
}
